import './serv.css'
const Serv = ({language}) => {
    const tariffsTr = {
        prase1: {
            eng: "On their personal page, the subscriber has the ability to:",
            fra: "Sur sa page personnelle, le téléspectateur a la possibilité de :"
        },    
        prase2: {
            eng: "- add or remove a decoder (decoders);",
            fra: "- ajouter ou supprimer un ou plusieurs décodeurs ;"
        },
        prase3: {
            eng: "- connect or disconnect TV packages;",
            fra: "- connecter ou déconnecter des progiciels ;"   
        },
        prase4: {
            eng: "- see the current balance and replenish it.",
            fra: "- voir le solde actuel et le reconstituer."  
        },
        prase5: {
            eng: "Watch the video instructions on using your personal account:",
            fra: "Regardez les instructions vidéo pour utiliser votre compte personne"
        },
    };
    const ytLinks = {
        eng: "https://www.youtube.com/embed/CWa5GawJMNI?si=h_HhQWG89vdJTkLS",
        fra: "https://www.youtube.com/embed/NojcByqnh2s?si=iqq4t0GNAv8Ebn5L"
    };
    return <div className='our-service-for-subs'>
        <div>
            <div>{tariffsTr?.prase1[language]}</div>
            <div>{tariffsTr?.prase2[language]}</div>
            <div>{tariffsTr?.prase3[language]}</div>
            <div>{tariffsTr?.prase4[language]}</div>
            <div>{tariffsTr?.prase5[language]}</div>
        </div>
        <div className='video-responsive-serv'>
            <iframe
            title="account installation" 
            src={ytLinks[language]}
            frameborder="0"
            allowfullscreen=""/>
        </div>
    </div>
}

export default Serv;